import { useState } from 'react';
import { Cradle, NewPasswordI } from '@solo/app-core';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { translate } from '@/app/i18n';
import { Button, Flex, Text, Icon, ChangePasswordForm, RouterLink } from '@/app/ui';
import Colors from '@/app/styles/Colors';
import { useCradle } from '@/app/contexts';

const ResetPasswordPage = () => {
  const { authBloc } = useCradle<Cradle>();
  const { token } = useParams();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [newPassword, setNewPassword] = useState<NewPasswordI>({
    password: '',
    repeatPassword: '',
  });
  const [changePassword, setChangePassword] = useState<boolean>(false);

  const resetPassword = async () => {
    if (!token) {
      toast.error(translate('RESET_PASSWORD.ERROR_RESET_PASSWORD'));
      return;
    }
    if (!newPassword.password || newPassword.password !== newPassword.repeatPassword) {
      toast.error(translate('RESET_PASSWORD.PASSWORDS_DO_NOT_MATCH'));
      return;
    }
    try {
      await authBloc.resetPassword({ token: token as string, password: newPassword.password });
      setChangePassword(true);
    } catch (error) {
      toast.error(translate('RESET_PASSWORD.ERROR_RESET_PASSWORD'));
    }
  };

  return (
    <Flex.Container
      flexDirection="column"
      alignItems="center"
      style={{ backgroundColor: Colors.white, marginTop: '15%' }}
    >
      {!changePassword && (
        <Flex.Container flexDirection="column" alignItems="center">
          <Flex.Item flex={1} className="mb-3">
            <Text.Title2 textAlign="center" style={{ fontStyle: 'italic' }}>
              {translate('RESET_PASSWORD.NEW_PASSWORD')}
            </Text.Title2>
            <Text.Paragraph>{translate('RESET_PASSWORD.ENTER_NEW_PASSWORD')}</Text.Paragraph>
          </Flex.Item>
          <Flex.Container style={{ width: '300px' }} flexDirection="column">
            <ChangePasswordForm onChange={setNewPassword} />
            <Flex.Item flex={1}>
              <Button $size="md" $full $variant="primary" onClick={resetPassword}>
                <Text.Span>{translate('RESET_PASSWORD.SEND_RESET_EMAIL')}</Text.Span>
              </Button>
            </Flex.Item>
          </Flex.Container>
        </Flex.Container>
      )}
      {changePassword && (
        <Flex.Container flexDirection="column" alignItems="center">
          <Icon.SpinnerCheckIcon width={120} />
          <Text.Title2>{translate('RESET_PASSWORD.YOUR_PASSWORD_HAS_BEEN_CHANGED')}</Text.Title2>
          <Text.Paragraph>{translate('RESET_PASSWORD.YOU_CAN_LOGIN')}</Text.Paragraph>
          <RouterLink $transparent to="/auth/login">
            <Text.SectionSubtitleBold style={{ color: Colors.primary }}>
              {translate('RESET_PASSWORD.GO_TO_LOGIN')}
            </Text.SectionSubtitleBold>
          </RouterLink>
        </Flex.Container>
      )}
    </Flex.Container>
  );
};
export default ResetPasswordPage;
